<div class="bg"></div>
<div class="text" [innerHTML]="text|wording"></div>
<div class="buttons">
    <app-button *ngIf="confirm.length>0" type="yellow" [key]="confirm" (click)="onButton(true)"></app-button>
    <app-button *ngIf="cancel.length>0" type="yellow" [key]="cancel" (click)="onButton(false)"></app-button>
</div>